/*
  Product page behaviour: <fd-gallery> (scroll-snap gallery + lightbox, variant image sync)
 . Depends on assets/fd-core.js.
*/
(function () {
  'use strict';
  if (!window.FD) return;
  var FD = window.FD;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class FdGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-fd-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.fd-gallery__slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-fd-thumb]'));
      this.countEl = this.querySelector('[data-fd-count]');
      this.lightbox = this.querySelector('[data-fd-lightbox]');
      this.index = 0;

      var self = this;
      var prev = this.querySelector('[data-fd-prev]');
      var next = this.querySelector('[data-fd-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-fd-thumb'), 10)); });
      });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) self._setActive(parseInt(en.target.getAttribute('data-index'), 10));
          });
        }, { root: this.track, threshold: 0.6 });
        this.slides.forEach(function (s) { io.observe(s); });
      }

      this.querySelectorAll('[data-fd-zoom]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (!self.lightbox || typeof self.lightbox.showModal !== 'function') return;
          e.preventDefault();
          self._openLightbox(a);
        });
      });

      // Variant change → show that variant's image.
      document.addEventListener('fd:variant:change', function (e) {
        var variant = e.detail && e.detail.variant;
        if (!variant || !variant.media) return;
        var idx = self.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(variant.media); });
        if (idx > -1) self.go(idx);
      });
    }

    go(i) {
      var n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      var slide = this.slides[i];
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      this._setActive(i);
    }

    _setActive(i) {
      if (isNaN(i)) return;
      this.index = i;
      if (this.countEl) this.countEl.textContent = (i + 1) + ' / ' + this.slides.length;
      this.thumbs.forEach(function (t, j) {
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    _openLightbox(anchor) {
      var img = this.lightbox.querySelector('[data-fd-lightbox-img]');
      var inner = anchor.querySelector('img');
      img.src = anchor.getAttribute('href');
      img.alt = inner ? inner.alt : '';
      this.lightbox.showModal();
    }
  }
  if (!customElements.get('fd-gallery')) customElements.define('fd-gallery', FdGallery);

  // Variant-level dimension and spec sheet (fall back to product values server-side).
  document.addEventListener("fd:variant:change", function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var dimRow = document.querySelector("[data-fd-dimension-row]");
    var dim = document.querySelector("[data-fd-dimension]");
    if (dimRow && dim) {
      dim.textContent = variant.dimension || "";
      dimRow.hidden = !variant.dimension;
    }
    var sheetRow = document.querySelector("[data-fd-sheet-row]");
    var sheet = document.querySelector("[data-fd-sheet]");
    if (sheetRow && sheet) {
      var ok = typeof variant.sheet === "string" && /^https:\/\//.test(variant.sheet);
      if (ok) sheet.setAttribute("href", variant.sheet);
      sheetRow.hidden = !ok;
    }
  });
})();
